import { parseNameTime } from "../components/DataView";

// Builds the set of performers present in the currently scraped roster data, as
// "venue::name" keys. Used to decide whether a subscription can link to a profile:
// details and photos are only captured while someone is being rostered, so linking
// a performer who has dropped off the roster risks opening an empty profile.
//
// Covers today and tomorrow, matching what the roster tables display. Names are run
// through parseNameTime so the keys line up with what NotifyButton stored when the
// user subscribed.

const key = (venue, name) => `${venue}::${name}`.trim().toLowerCase();

const namesFrom = (entries) =>
  (entries || [])
    .map((entry) => parseNameTime(entry).name)
    .map((name) => (name || "").replace(/[\s-]+$/, "").trim())
    .filter(Boolean);

export function buildRosteredKeys(data) {
  const keys = new Set();
  if (!data) return keys;

  const add = (venue, entries) => {
    namesFrom(entries).forEach((name) => keys.add(key(venue, name)));
  };

  add("marrickville", data.no5?.today);
  add("marrickville", data.no5?.tomorrow);

  add("gladesville", data.nightshade?.today);
  add("gladesville", data.nightshade?.tomorrow);

  // The Ginza-template venues expose rosters as an ordered [today, tomorrow] list.
  (data.ginza?.rosters || []).forEach((block) => add("cleveland", block?.names));
  (data.ginza479?.rosters || []).forEach((block) => add("elizabeth", block?.names));

  return keys;
}

export function isRostered(rosteredKeys, venue, performerName) {
  if (!rosteredKeys) return false;
  return rosteredKeys.has(key(venue, (performerName || "").replace(/[\s-]+$/, "")));
}
